export const Companies = {
  OBBY: "obby",
  BALUU: "baluu"
};
